// extracted by mini-css-extract-plugin
export default {"infoIntroductionBox":"infoIntroduction_infoIntroductionBox__4YB8l","contentTypes":"infoIntroduction_contentTypes__NG0By"};